/*------
タブレット用
------*/
function viewportSet() {
  //画面幅428以下かどうかチェック（スマホ）
  function isMobileWidth() {
    const ww = window.innerWidth;
    return ww <= 428;
  }

  const metaViewport = document.querySelector("meta[name='viewport']");

  if (isMobileWidth()) {
    // デバイス横幅428px以下
    metaViewport.setAttribute("content", "width=device-width,initial-scale=1.0,viewport-fit=cover")
  } else {
    metaViewport.setAttribute("content", "width=1400")
  }
}

window.addEventListener("orientationchange", viewportSet)


/*------
モーダルの高さを算出するため
※モーダルのクローズボタンや、メタマップの下ボタンの位置の算出に使用
------*/
function setModalInnerHeightVar(modalInnerElm, varName = '--modal-inner-height') {
  if (!modalInnerElm) return
  const height = modalInnerElm.getBoundingClientRect().height
  document.documentElement.style.setProperty(varName, `${height}px`)
}

window.addEventListener('load', () => {
  // viewport初期化
  viewportSet()


  /*------
  URLパスから言語を検出し、platinumapsリンクのcultureパラメータを置換
  ------*/
  const cultureMap = { en: 'en', ko: 'ko', zhcn: 'zh-cn', zhtw: 'zh-tw' }
  const langMatch = location.pathname.match(/\/translate\/(\w+)\//)
  const currentCulture = langMatch ? (cultureMap[langMatch[1]] || 'en') : 'en'

  document.querySelectorAll('a[href*="platinumaps.jp"]').forEach(a => {
    a.setAttribute('href', a.getAttribute('href').replace(/culture=\w[\w-]*/g, 'culture=' + currentCulture))
  })


  // 翻訳時にタイトルにhtmlソースが入ってしまうので、textをhtmlにパースして、textに戻すという作戦
  // ※リニューアル前にあったコードで、削除OKかわからなかったので残してあります。
  const title = document.title
  const tempDom = document.createElement('section');
  tempDom.innerHTML = title;
  document.title = tempDom.innerText;


  /*------
  ハンバーガーメニュー開閉
  ------*/
  const hmbOpenElm = document.querySelector('.js-hmb_open')
  const hmbCloseElm = document.querySelectorAll('.js-hmb_close')

  if(hmbOpenElm) {
    hmbOpenElm.addEventListener('click', function(e) {
      e.preventDefault()
      document.querySelector('body').classList.toggle('is_hmb_open')

      // 他のモーダルが開いていたら閉じる
      document.querySelector('body').classList.remove('is_pay_modal_open')
      document.querySelector('body').classList.remove('is_metamap_modal_open')
      document.querySelector('body').classList.remove('is_filter_open')
      document.querySelector('body').classList.remove('is_modal_open')
    })

    hmbCloseElm.forEach(elm => {
      elm.addEventListener('click', function() {
        document.querySelector('body').classList.remove('is_hmb_open')
      })
    })
  }
  

  /*------
  paymentモ－ダル開閉
  ------*/
  const payModalOpenElm = document.querySelector('.js-pay_modal_open')
  const payModalCloseElm = document.querySelectorAll('.js-pay_modal_close')
  const payModalContentElm = document.querySelector('.js-pay_modal_content')

  if(payModalOpenElm) {
    payModalOpenElm.addEventListener('click', function(e) {
      e.preventDefault()
      document.querySelector('body').classList.toggle('is_pay_modal_open')
    })

    payModalCloseElm.forEach(elm => {
      elm.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('body').classList.remove('is_pay_modal_open')

        // モーダルを閉じたとき、スクロール位置を一番上に戻す
        payModalContentElm.scrollTop = 0;
      })
    })

    // モーダルクローズボタン位置を算出するため
    setModalInnerHeightVar(payModalContentElm, '--pay-inner-height')
  
    window.addEventListener('resize', () => {
      setModalInnerHeightVar(payModalContentElm, '--pay-inner-height')
    })
  }
  

  /*------
  metamapモ－ダル開閉
  ------*/
  const metamapModalOpenElms = document.querySelectorAll('.js-metamap_modal_open')
  const metamapModalCloseElm = document.querySelectorAll('.js-metamap_modal_close')
  const metamapiFrameElm = document.querySelector(".js-metamap_iframe")
  const metamapBtnElm = document.querySelector(".js-metamap_btn")

  metamapModalOpenElms.forEach(elm => {
    elm.addEventListener('click', function(e) {
      e.preventDefault()

      const rawUrl = elm.getAttribute('href')
      const url = rawUrl ? rawUrl.replace(/culture=\w[\w-]*/g, 'culture=' + currentCulture) : rawUrl

      // モーダルを開く
      document.querySelector('body').classList.add('is_metamap_modal_open')

      if (metamapiFrameElm) {
        if (url) {
          // hrefがある場合: 読み込み完了後またはタイムアウトでis_metamap_modal_showを付与
          // is_metamap_modal_showクラスは、iframeが読み込まれてからコンテンツをフェードで表示するため
          metamapiFrameElm.classList.remove('is_metamap_modal_show')
          const onIframeLoad = () => {
            metamapiFrameElm.classList.add('is_metamap_modal_show')
            metamapiFrameElm.removeEventListener('load', onIframeLoad)
            clearTimeout(showTimeoutId)
          }
          const SHOW_DELAY_MS = 5000
          const showTimeoutId = setTimeout(() => {
            metamapiFrameElm.classList.add('is_metamap_modal_show')
            metamapiFrameElm.removeEventListener('load', onIframeLoad)
          }, SHOW_DELAY_MS)
          metamapiFrameElm.addEventListener('load', onIframeLoad)
          metamapiFrameElm.setAttribute('src', url)
          metamapBtnElm.setAttribute('href', url)
        } else {
          // hrefが空の場合は読み込みを待たずにすぐis_metamap_modal_showを付与
          metamapiFrameElm.classList.add('is_metamap_modal_show')
          document.querySelector('body').classList.add('is_metamap_commingsoon')
        }
      }
    })
  })

  // モーダルを閉じる（bodyのクラス解除、iframeのsrcを空に、is_metamap_modal_showを外す）
  metamapModalCloseElm.forEach(elm => {
    elm.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('body').classList.remove('is_metamap_modal_open')
      if (metamapiFrameElm) {
        metamapiFrameElm.setAttribute('src', '')
        metamapBtnElm.setAttribute('href', '')
        metamapiFrameElm.classList.remove('is_metamap_modal_show')
        document.querySelector('body').classList.remove('is_metamap_commingsoon')
      }
    })
  })

  // モーダルのクローズボタン・下のボタン位置を算出するため
  const metamapModalInnerElm = document.querySelector('.js-metamap_inner')
  setModalInnerHeightVar(metamapModalInnerElm, '--metamap-inner-height')

  window.addEventListener('resize', () => {
    setModalInnerHeightVar(metamapModalInnerElm, '--metamap-inner-height')
  })

  /*------
  通常のモ－ダル開閉
  ※facilityページ「フロアへのアクセス」セクション等で使用
  ------*/
  const modalOpenElm = document.querySelector('.js-modal_open')
  const modalCloseElms = document.querySelectorAll('.js-modal_close')
  const modalContentElm = document.querySelector('.js-modal_content')

  if(modalOpenElm) {
    modalOpenElm.addEventListener('click', function(e) {
      e.preventDefault()
      document.querySelector('body').classList.toggle('is_modal_open')
    })

    modalCloseElms.forEach(elm => {
      elm.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('body').classList.remove('is_modal_open')

        // モーダルを閉じたとき、スクロール位置を一番上に戻す
        modalContentElm.scrollTop = 0;
      })
    })

    // モーダルクローズボタン位置を算出するため
    setModalInnerHeightVar(modalContentElm, '--modal-inner-height')
  
    window.addEventListener('resize', () => {
      setModalInnerHeightVar(modalContentElm, '--modal-inner-height')
    })
  }

  
  /*------
  フッターが画面内に入った時
  ------*/
  const footerElm = document.querySelector(".js-footer");

  function checkFooterInView() {
    if (!footerElm) return;
    const rect = footerElm.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    // フッターが画面内に入っているとみなす条件（上下いずれかが可視領域にある場合）
    if (
      (rect.top <= windowHeight && rect.bottom >= 0)
    ) {
      document.querySelector('body').classList.add('is_show_footer');
    } else {
      document.querySelector('body').classList.remove('is_show_footer');
    }
  }

  checkFooterInView()
  window.addEventListener('scroll', checkFooterInView);
  window.addEventListener('resize', checkFooterInView);

  /*------
  スクロールイベント
  ------*/
  // フェードイン
  function handleFadeIn() {
    const fadeElements = document.querySelectorAll('.js-fadein')
    const windowHeight = window.innerHeight

    fadeElements.forEach(element => {
      // フェードインのタイミングを設定 ※data-fadein_timing属性で設定可能。デフォルトは0.7 ※数字が大きいほどタイミングが早い
      const fadeinTiming = element.dataset.fadein_timing || 0.7

      const elementTop = element.getBoundingClientRect().top
      if (elementTop < windowHeight * fadeinTiming) {
        element.classList.add('is_show')
      } else {
        element.classList.remove('is_show')
      }
    })
  }

  // 初期化時に一度実行
  handleFadeIn()

  // スクロール時にも実行
  window.addEventListener('scroll', () => {
    handleFadeIn()
  })

})